import React from "react"
import CampaignListTableComponent from "./campaignListTable.component"

export default function CampaignListTableContainer({
  rows,
  isFetching,
  isError,
  page,
  tableFilter,
  rowsPerPage,
  totalFiltered,
  handleChangePage,
  handleChangeRowsPerPage,
  handleReload,
  paginationOptions,
  changeOrder,
  lang,
  language,
  handleViewDetail
}) {
  return (
    <CampaignListTableComponent
      rows={rows}
      isFetching={isFetching}
      isError={isError}
      language={language}
      handleReload={handleReload}
      page={page}
      rowsPerPage={rowsPerPage}
      totalFiltered={totalFiltered}
      paginationOptions={paginationOptions}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      tableFilter={tableFilter}
      changeOrder={changeOrder}
      lang={lang}
      handleViewDetail={handleViewDetail}
    />
  )
}
